import React, { useState, useEffect } from "react";
import DataChart from "../../../common/DataChart/DataChart";
import { useGetBookedOrdersChartDataByUserIdQuery } from "../diagramsSlice";
import LoadingSpinner from "../../../common/LoadingSpinner/LoadingSpinner";
import { selectCurrentUser } from "../../../../features/auth/authSlice";
import { useSelector } from "react-redux";

const BookedOrdersChart = ({
  width,
  height,
  isAutomated,
  isDisabled,
  timeInterval,
  fontSize,
  margin,
}) => {
  const [type, setType] = useState("year");

  function handleChildClick(value) {
    setType(value);
  }
  const user = useSelector(selectCurrentUser);

  const {
    data: bookedOrdersChartData,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetBookedOrdersChartDataByUserIdQuery({
    userId: user.userID,
    type: type,
  });

  const [bookedOrdersData, setBookedOrdersData] = useState([]);

  useEffect(() => {
    if (bookedOrdersChartData) {
      const data = bookedOrdersChartData.ids.map((id) => {
        return bookedOrdersChartData.entities[id];
      });
      setBookedOrdersData(data);
    }
  }, [bookedOrdersChartData, type]);

  return (
    <div className="chart-container" id="barchart-container">
      {isLoading && <LoadingSpinner />}
      {bookedOrdersData.length > 0 && (
        <DataChart
          chartData={bookedOrdersData}
          title={"Booked Orders"}
          category={"bookedOrders"}
          width={width}
          height={height}
          handleFilter={handleChildClick}
          isAutomated={isAutomated}
          isDisabled={isDisabled}
          timeInterval={timeInterval}
          refetch={refetch}
          fontSize={fontSize}
          margin={margin}
        />
      )}
    </div>
  );
};

export default BookedOrdersChart;
